<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Accredited Institutes</v-card-title>
      <v-divider />

      <v-card-text class="mx-auto">
        <v-data-table
          :headers="accreditedInstituteHeaders"
          :items="accreditedInstitute"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: "accreditedInstitute",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Dashboard/getaccreditedInstitute");
    });
  },
  computed: {
    accreditedInstituteHeaders() {
      return [
        {
          text: "code",
          align: "center",
          sortable: false,
          width: "500px",
          value: "code",
        },
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
    },
    accreditedInstitute() {
      return this.$store.getters["Dashboard/accreditedInstitute"];
    },
  },
};
</script>
